export default __webpack_public_path__ + "static/media/location_preview_cascade_failure.91fcbdf8.svg";